export default __webpack_public_path__ + "static/media/flag-indonesia.067da76b.svg";